<template>
    <v-stepper v-model="activeStep" aria-live="polite">

        <v-stepper-header>
            <template v-for="(step, i) in steps">
                <v-stepper-step :key="`step-${i}-headder`" :id="`step-${i}-header`" :complete="activeStep > i + 1" :step="i + 1" complete-icon="check">
                    <span v-if="activeStep > i + 1" class="visually-hidden">Complete: </span>
                    <span v-else-if="activeStep === i + 1" class="visually-hidden">Current: </span>
                    {{ step }}
                </v-stepper-step>
            </template>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content v-for="(step, i) in steps" :step="i + 1" :key="`${i}-step`" :aria-labelledby="`step-${i}-header`">
                <slot :name="step.replace(' ', '-')" />
            </v-stepper-content>
        </v-stepper-items>

    </v-stepper>
</template>

<script lang="ts">
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component
export default class AccessibleStepper extends Vue
{
    @VModel({ type: Number, default: 1 }) activeStep: number;
    @Prop({ type: Array, required: true }) steps: string[]
}
</script>
